import React, { useState, useRef, useEffect } from "react";

export default function UserMenu({
  onView,
  onEditPersonal,
  onEditEmployment,
  onArchive,
}) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="relative inline-block text-left" ref={menuRef}>
      <button
        aria-label="Open menu"
        className="py-1 px-4 rounded-md hover:bg-gray-200 "
        onClick={() => setOpen((v) => !v)}
        type="button"
      >
        {/* Font Awesome vertical ellipsis using <i> */}
        <i className="fa fa-ellipsis-v text-black-800 text-lg"></i>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white flex flex-wrap shadow-lg ring-1 ring-black ring-opacity-5 z-50">
          <button
            className="w-full text-left px-4 py-2 text-sm text-gray-900 hover:bg-gray-100"
            onClick={() => {
              setOpen(false);
              onView && onView();
            }}
          >
            <i className="w-4 fa fa-eye mr-2 text-gray-500"></i>
            View
          </button>
          <button
            className="w-full text-left px-4 py-2 text-sm text-gray-900 hover:bg-gray-100"
            onClick={() => {
              setOpen(false);
              onEditPersonal && onEditPersonal();
            }}
          >
            <i className="w-4 fa fa-user-edit mr-2 text-gray-500"></i>
            Edit Personal
          </button>
          <button
            className="w-full text-left px-4 py-2 text-sm text-gray-900 hover:bg-gray-100"
            onClick={() => {
              setOpen(false);
              onEditEmployment && onEditEmployment();
            }}
          >
            <i className="w-4 fa fa-briefcase mr-2 text-gray-500"></i>
            Edit Employment
          </button>

          <button
            className="w-full text-left px-4 py-2 text-sm text-gray-900 hover:bg-gray-100"
            onClick={() => {
              setOpen(false);
              onArchive && onArchive();
            }}
          >
            <i className="w-4 fa fa-archive mr-2 text-gray-500"></i>
            Archive Person
          </button>
        </div>
      )}
    </div>
  );
}
